module.exports = __webpack_public_path__ + "static/media/cert_13.0ac6584e.jpg";